import { render, staticRenderFns } from "./CreateOrEditAdminQuotation.vue?vue&type=template&id=219785b0&scoped=true&"
import script from "./CreateOrEditAdminQuotation.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditAdminQuotation.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditAdminQuotation.vue?vue&type=style&index=0&id=219785b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219785b0",
  null
  
)

export default component.exports